import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "./Home";
import Seo from "../components/Seo";

const Legal = ({ docKey }) => {
  const ref = useReveal();
  const navigate = useNavigate();
  const { t, lp } = useLang();
  const doc = t.legal[docKey];

  return (
    <div ref={ref}>
      <Seo title={t.seo[docKey].title} description={t.seo[docKey].description} />
      <section className="relative overflow-hidden bg-[#0f1a10] pb-16 pt-40">
        <div className="absolute inset-0 opacity-15">
          <img src={t.hero.slides[0]} alt="" className="h-full w-full object-cover grayscale" />
        </div>
        <div className="relative mx-auto max-w-[820px] px-6">
          <button onClick={() => navigate(lp("/"))} className="inline-flex items-center gap-2 text-sm font-medium text-neutral-300 transition-colors hover:text-[#F26522]">
            <ArrowLeft className="h-4 w-4" /> Home
          </button>
          <h1 className="mt-6 text-4xl font-extrabold leading-tight text-white lg:text-5xl">{doc.title}</h1>
          <p className="mt-3 text-lg text-neutral-300">{doc.subtitle}</p>
        </div>
      </section>

      <section className="mx-auto max-w-[820px] px-6 py-16 lg:py-20">
        <div className="space-y-10">
          {doc.sections.map((s) => (
            <div key={s.heading} className="reveal">
              <h2 className="text-xl font-bold text-neutral-900">{s.heading}</h2>
              <p className="mt-3 whitespace-pre-line text-[15px] leading-relaxed text-neutral-700">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Legal;
